(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card"] && !Shopify.designMode) return;
  try {
    function setupCollectionShopStickers() {
    document.querySelectorAll('main .collection-card').forEach((card) => {
      if (card.querySelector('.kc-shop-sticker')) return;

      const oldButton = Array.from(
        card.querySelectorAll('.collection-card__content .button')
      ).find((button) =>
        button.textContent.trim().toLowerCase().startsWith('jetzt shoppen')
      );

      if (!oldButton) return;

      const sticker = document.createElement('span');
      sticker.className = 'kc-shop-sticker';
      sticker.textContent = 'Shop';
      sticker.setAttribute('aria-hidden', 'true');
      card.appendChild(sticker);
      oldButton.classList.add('kc-sticker-original-button');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCollectionShopStickers);
  } else {
    setupCollectionShopStickers();
  }

  document.addEventListener('shopify:section:load', setupCollectionShopStickers);
  } catch(e) { console.error(e); }
})();

})();
